import { PlatformsImage } from "@/components/package-components/non-editable/core";
import { About1Props } from "../../props";
import styles from "./about-variant-01.module.scss";
import Dots from "@/components/package-components/non-editable/misc/dots";

export const AboutVariant01 = (props: About1Props) => (
  <section className={`${styles.container} container-${props.id}`}>
    {typeof props.inverter != "undefined" && (
      <div
        className={`${
          props.inverter?.value ?? props.inverter
            ? `${styles["wrapper--invert"]} wrapper--invert-${props.id}`
            : `wrapper--invert-${props.id}`
        } ${styles.wrapper} wrapper-${props.id}`}
      >
        <div className={`${styles["text-wrapper"]} text-wrapper-${props.id}`}>
          {typeof props.heading != "undefined" && (
            <h2>
              {props.heading?.value ?? (props.heading as unknown as string)}
            </h2>
          )}

          {typeof props.description != "undefined" && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (props.description.value as string) ??
                  (props.description as unknown as string),
              }}
            />
          )}
        </div>

        {(props.image?.value || props.image) && (
          <div
            className={`${styles["image-container"]} image-container-${props.id}`}
          >
            <PlatformsImage
              width={385}
              height={288}
              priority
              className={`${styles.image} image-${props.id}`}
              src={String(props?.image?.value ?? props?.image).replace(
                "blob:",
                ""
              )}
              alt=""
            />

            <Dots
              invert={(props.inverter?.value ?? props.inverter) as boolean}
            />
          </div>
        )}
      </div>
    )}
  </section>
);
